import { Box, Stack } from "@mui/joy";
import { ReactNode } from "react";

// A quest tab's white card on the overview's grey background, with an optional column beside it,
// such as the Rules tab's credit preview.
export default function QuestTabLayout({
  children,
  aside,
}: {
  children: ReactNode;
  aside?: ReactNode;
}) {
  return (
    <Stack direction={{ xs: "column", md: "row" }} gap={1.5} sx={{ flex: 1, minHeight: 0 }}>
      <Stack
        sx={{
          backgroundColor: "white",
          borderRadius: 8,
          overflow: "hidden",
          flex: 1,
          minHeight: 0,
          maxWidth: 800,
        }}
      >
        {children}
      </Stack>
      {aside ? (
        <Box sx={{ width: { md: 320 }, flexShrink: 0, overflowY: "auto" }}>{aside}</Box>
      ) : null}
    </Stack>
  );
}
